var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'rotation-wrapper-' + _vm.orientation},[_c('b-img-lazy',{staticClass:"card-img-top",class:'rotate-' + _vm.orientation,attrs:{"rounded":"0","src":_vm.image,"alt":_vm.challengeResult.challenge.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }